var $a3dd26e20adf6e63$exports = {};
$a3dd26e20adf6e63$exports = {
    "endTime": `Ora di fine`,
    "startTime": `Ora di inizio`,
    "time": `Ora`
};


export {$a3dd26e20adf6e63$exports as default};
//# sourceMappingURL=it-IT.module.js.map
